module.exports = __webpack_public_path__ + "static/media/SailBoat.ae326e31.png";